import { axios } from '@Root/API'

export const get = programmeId => {
	return axios.get(`program/${programmeId}`)
}
